window.TUCCoursemap = SiCoursemap.extend({
    render: function() {
        this.complete();
        var router = this.controller ? this.controller : this.app.session;
        router.startModule(1);
    }
});
